export class SubscriptionsearchClass {

  SearchdropFirst: string = '';
  SearchdropSecond: string = '';
  SearchMatchesFirst: string = '';
  SearchMatchesSecond: string = '';
  SearchtextFirst: any = '';
  SearchtextSecond: any = '';
  SearchdropFirstList: any[] = [
    { Value: 'Module', Text: 'Module' },
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'OrgCode', Text: 'Org Code' },
    { Value: 'EntityCode', Text: 'Entity Code' },
    { Value: 'Status', Text: 'Status' },
    { Value: 'BillingStartDate', Text: 'Billing Start Date' },
    { Value: 'TerminationDate', Text: 'Termination Date' }
  ]
  SearchdropSecondList: any[] = [
    { Value: 'Module', Text: 'Module' },
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'OrgCode', Text: 'Org Code' },
    { Value: 'EntityCode', Text: 'Entity Code' },
    { Value: 'Status', Text: 'Status' },
    { Value: 'BillingStartDate', Text: 'Billing Start Date' },
    { Value: 'TerminationDate', Text: 'Termination Date' }
  ]
}




// WEBPACK FOOTER //
// ./src/app/Classes/SubscriptionsearchClass.ts